import React, { useState } from 'react';

import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import {
	Box,
	IconButton,
	InputAdornment,
	InputProps,
	TextField as MUITextField,
	TextFieldProps,
	Typography,
} from '@mui/material';
import { FieldConfig, FieldProps, Field as FormikField } from 'formik';

export type TTextFieldProps = InputProps &
	FieldConfig &
	TextFieldProps & {
		fullWidth?: boolean;
		withWordsCounter?: boolean;
		withCharsCounter?: boolean;
		charsCounterLimit?: number;
	};

function TextField({
	name,
	type,
	fullWidth = true,
	withWordsCounter,
	withCharsCounter,
	charsCounterLimit,
	...props
}: TTextFieldProps) {
	const [isShowPassword, setIsShowPassword] = useState(false);

	const handleClickShowPassword = () => setIsShowPassword((value) => !value);

	return (
		<FormikField name={name}>
			{({ field, meta }: FieldProps) => {
				const wordsCount = field.value?.length ? field.value?.trim().split(' ')?.length : 0;
				const charsCount = String(field.value ?? '').length;
				const showWordsCounter = Boolean(withWordsCounter);
				const showCharsCounter = Boolean(withCharsCounter || withWordsCounter);

				return (
					<Box sx={{ position: 'relative' }}>
						<MUITextField
							fullWidth={fullWidth}
							variant="outlined"
							error={meta.touched && !!meta.error}
							helperText={meta.touched && !!meta.error ? meta.error : ''}
							type={isShowPassword ? 'text' : type}
							sx={{
								'& .MuiInputBase-input::-ms-reveal': {
									display: 'none',
								},
							}}
							InputProps={
								type === 'password'
									? {
											endAdornment: (
												<InputAdornment position="end">
													<IconButton
														onClick={handleClickShowPassword}
														edge="end"
														sx={{ height: 'auto' }}
													>
														{isShowPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
													</IconButton>
												</InputAdornment>
											),
										}
									: {}
							}
							{...field}
							value={field.value ?? ''}
							{...props}
						/>
						{(showWordsCounter || showCharsCounter) && (
							<>
								{showWordsCounter && (
									<Typography fontSize="14px" fontWeight="500" color="#C4C6C7">
										{`Words count: ${wordsCount}`}
									</Typography>
								)}
								{showCharsCounter && (
									<Typography
										sx={{
											position: 'absolute',
											backgroundColor: '#fff',
											bottom: '-9px',
											right: '15px',
											padding: '0 4px',
										}}
										fontSize="14px"
										fontWeight="500"
										color="#C4C6C7"
									>
										{`Chars count: ${charsCount}${
											typeof charsCounterLimit === 'number'
												? ` of ${charsCounterLimit}`
												: ''
										}`}
									</Typography>
								)}
							</>
						)}
					</Box>
				);
			}}
		</FormikField>
	);
}

export default TextField;
